import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/itm-3.png';
import Img1 from '../../../assets/images/itm-2.png';
import Img2 from '../../../assets/images/itm-6.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-7.png';

const introSectionData15: IntroSectionData = {
  sectionTitle: "Expertise",
  sectionSubtitle: "Notre savoir-faire en IA",
  translationNamespace: "labAI",
  tabsData: [
    {
      id: 0,
      title: "Innovation",
      heading: "Moteur d'innovation",
      text: "Nos équipes explorent, testent et maîtrisent les technologies d'intelligence artificielle émergentes appliquées aux scénarios d'entreprise. Le lab nous permet de nous positionner à la pointe des avancées de l'IA et de développer des solutions novatrices spécifiquement adaptées aux défis de nos clients.",
      key: "innovation"
    },
    {
      id: 1,
      title: "Agentique",
      heading: "Conception d'Écosystèmes d'Agents IA",
      text: "Nous excellons dans la conception et l'implémentation d'écosystèmes d'agents IA collaboratifs. Comprenant que la valeur de l'IA en entreprise réside dans l'intelligence collective, nous architecturons des systèmes où des agents spécialisés interagissent harmonieusement. Cette compétence clé permet d'aller au-delà des automatisations simples pour bâtir des solutions capables de gérer des processus complexes.",
      key: "agentique"
    },
    {
      id: 2,
      title: "Optimisation",
      heading: "Optimisation des processus métiers",
      text: "Notre savoir-faire en IA est directement orienté vers l'amélioration des performances et la création de valeur métier. Nous travaillons en étroite collaboration avec les entreprises pour identifier les cas d'usage pertinents où l'IA, et notamment les écosystèmes d'agents, peut générer un impact significatif.",
      key: "optimization"
    },
    {
      id: 3,
      title: "Confidentialité",
      heading: "Sécurité et confidentialité des données",
      text: "Conscients des enjeux de sécurité liés au déploiement de l'IA, nous intégrons nativement la cybersécurité dans notre approche. Notre expertise nous permet d'analyser les risques spécifiques aux systèmes d'intelligence artificielle et de mettre en place des mesures de protection robustes.",
      key: "confidentialite"
    },
  ],
  fixedImageSrc: Img0,
  fixedImageAlt: "IT Monkeys AI Lab",
};

export default introSectionData15;